import "./rma-items.scss";
import IconReserveItem from "../../../../../components/icons/icon-reserve-item/icon-reserve-item";
import { Tooltip } from "../../../../../components/tooltip/tooltip";
import { IReservedItemsInfo } from "../../stores/rma-item-store";
import { observer } from "mobx-react";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";

interface IProps {
    reserveItemsInfo: IReservedItemsInfo;
}

const ReserveItemsIndicator: React.FC<IProps> = observer(({ reserveItemsInfo }) => {
    return (
        <div >
            <Tooltip variant={reserveItemsInfo.tooltipVariant} content={
                <div className="reserve-items-indicator-tooltip">
                    <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
                        {reserveItemsInfo.tooltipText}
                    </FontBody2>
                </div>}>
                <IconReserveItem color={reserveItemsInfo.iconColor} />
            </Tooltip>
        </div>
    );
});

export default ReserveItemsIndicator;
